import * as React from "react";
import styled from "styled-components";
import { getOrgOwner } from "../../libs/organization";

const OrgLogo = styled.img`
  width: 100%;
`;

interface IProps {
  org: IOrganization;
  owner: IUser;
}

interface IState {
  owner?: IUser;
}

class OrgProfile extends React.Component<IProps, IState> {
  state: IState = {};

  render() {
    const { org, owner } = this.props;
    if (!owner) return null;

    return (
      <div>
        {org.logo ? <OrgLogo src={org.logo} className="img-rounded" /> : null}
        <h2>{org.name}</h2>
        <p>
          <span className="label label-info">Owner</span>{" "}
          <a href={Routes.employee_path(owner.id)}>{owner.name}</a>
        </p>
      </div>
    );
  }
}

export default OrgProfile;



// WEBPACK FOOTER //
// ./app/javascript/components/org/OrgProfile.tsx